import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenicationService } from '../../_services/authenication.service';
import { PricesService } from '../../_services/prices.service';
import { RegionService } from '../../_services/region.service';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-couponcode',
  templateUrl: './add-couponcode.component.html',
  styleUrls: ['./add-couponcode.component.css']
})
export class AddCouponcodeComponent implements OnInit {

  addPromoCodeForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  regionList: any[] = [];
  promoCodeList: any[] = [];
  tempPromoCodeList: any[] = [];
  isDataAvailable: boolean = false;
  more_value: 0;
  regionDropdownData = [];
  selectedRegion  = [];
  selectedPlan  = [];
  selectedRegionItemsRoot  = [];
  selectedPlanItemsRoot  = [];
  userId: '';
  selectedKind = "";
  dropdownSettings={}
  plansDropdownSettings={}
  invalidValue = false;
  selectedType = "";
  mentionedValue = 0;

  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private pricesService: PricesService, private spinnerService: Ng4LoadingSpinnerService, private regionService: RegionService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    // tslint:disable-next-line:triple-equals
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    this.getPlans();
    this.getRegions();

    this.userId = this.userdetaild['_id'];




    this.addPromoCodeForm = this.formBuilder.group({
      kind: ['', [Validators.required]],
      code: ['', [Validators.required, Validators.maxLength(6)]],
      type: ['', [Validators.required]],
      value: [''],
      // INR: [''],
      // SGD: [''],
      region: ['', [Validators.required]],
      plans: [''],
      slots: ['', [Validators.required]],
      slots_per_user: ['', [Validators.required]],
      expiry: ['', [Validators.required]],
      status: ['', [Validators.required]]
    });



    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

  }

  onValueChange(item:any){
    this.mentionedValue = item.target.value;
    this.checkValue();
  }

  onKindSelect(item:any){
    this.selectedKind = item.target.value;
    this.selectedRegion = [];
    this.selectedRegionItemsRoot = [];
    if(item.target.value === "COUPON_FLAT"){
    this.dropdownSettings = {...this.dropdownSettings, singleSelection: true}
  }else{
    this.dropdownSettings = {...this.dropdownSettings, singleSelection: false}
    }
   }

  onTypeChange(event:any){
    this.selectedType = event.target.value;
    this.selectedPlan = [];
    this.selectedPlanItemsRoot = [];
    this.updatePromoCodeList();
  }

  onItemSelect(item:any){
    this.selectedRegion.push(this.regionList[this.regionDropdownData.indexOf(item)]['_id']);
    this.selectedRegionItemsRoot.push(this.regionList[this.regionDropdownData.indexOf(item)]['_id']);
    this.selectedPlan = [];
    this.selectedPlanItemsRoot = [];
    this.updatePromoCodeList();
  }
   OnItemDeSelect(item:any){
     this.selectedRegion.splice(this.selectedRegion.indexOf(this.regionList[this.regionDropdownData.indexOf(item)]['_id']),1);
     this.selectedRegionItemsRoot.splice(this.selectedRegionItemsRoot.indexOf(this.regionList[this.regionDropdownData.indexOf(item)]['_id']),1);
     this.selectedPlan = [];
     this.selectedPlanItemsRoot = [];
     this.updatePromoCodeList();
    }
   onSelectAll(items: any) {
    this.selectedRegion = [];
    this.selectedRegionItemsRoot = [];
    this.selectedPlan = [];
    this.selectedPlanItemsRoot = [];
    this.updatePromoCodeList();
  }


  onPlanItemSelect(item:any){
    const planBifer = item.split("-");
    this.selectedPlan.push(this.tempPromoCodeList.filter(plan=> plan.type===planBifer[0] && plan.name === planBifer[1] && (plan.regions ? plan.regions.name === planBifer[2] : true) )[0]['_id']);
    this.selectedPlanItemsRoot.push(this.tempPromoCodeList.filter(plan=> plan.type===planBifer[0] && plan.name === planBifer[1] && (plan.regions ? plan.regions.name === planBifer[2] : true) )[0]['_id']);
    this.checkValue();
  }
   OnPlanItemDeSelect(item:any){
    let planBifer = item.split("-");
     this.selectedPlan.splice(this.selectedPlan.indexOf(this.tempPromoCodeList.filter(plan=> plan.type===planBifer[0] && plan.name === planBifer[1] && (plan.regions ? plan.regions.name === planBifer[2] : true) )[0]['_id']),1);
     this.selectedPlanItemsRoot.splice(this.selectedPlanItemsRoot.indexOf(this.tempPromoCodeList.filter(plan=> plan.type===planBifer[0] && plan.name === planBifer[1] && (plan.regions ? plan.regions.name === planBifer[2] : true) )[0]['_id']),1);
     this.checkValue();
    }
  onSelectAllPlans(items: any) {
    items.map(item=>{
      let planBifer = item.split("-");
      if(!this.selectedPlan.includes(this.tempPromoCodeList.filter(plan=> plan.type===planBifer[0] && plan.name === planBifer[1] && (plan.regions ? plan.regions.name === planBifer[2] : true) )[0]['_id'])){
        this.selectedPlan.push(this.tempPromoCodeList.filter(plan=> plan.type===planBifer[0] && plan.name === planBifer[1] && (plan.regions ? plan.regions.name === planBifer[2] : true) )[0]['_id']);
      }
      if(!this.selectedPlanItemsRoot.includes(this.tempPromoCodeList.filter(plan=> plan.type===planBifer[0] && plan.name === planBifer[1] && (plan.regions ? plan.regions.name === planBifer[2] : true) )[0]['_id'])){
        this.selectedPlanItemsRoot.push(this.tempPromoCodeList.filter(plan=> plan.type===planBifer[0] && plan.name === planBifer[1] && (plan.regions ? plan.regions.name === planBifer[2] : true) )[0]['_id']);
      }
    })
    this.checkValue();
  }

  get f() { return this.addPromoCodeForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addPromoCodeForm.invalid || this.invalidValue) {
      console.log(this.addPromoCodeForm);

      this.spinnerService.hide();
      return;
    }
    // let flat = {
    //   INR: (this.addPromoCodeForm.controls.INR.value)?this.addPromoCodeForm.controls.INR.value:0,
    //   SGD: (this.addPromoCodeForm.controls.SGD.value)?this.addPromoCodeForm.controls.SGD.value:0,
    // }

    const addPayload = {
      kind: this.addPromoCodeForm.controls.kind.value,
      type: this.addPromoCodeForm.controls.type.value,
      code: this.addPromoCodeForm.controls.code.value.toUpperCase(),
      value: this.addPromoCodeForm.controls.value.value,
      region: this.selectedRegion.join(","),
      // flat: flat,
      slots: (this.addPromoCodeForm.controls.slots.value) ? this.addPromoCodeForm.controls.slots.value : 0,
      slots_per_user: (this.addPromoCodeForm.controls.slots_per_user.value) ? this.addPromoCodeForm.controls.slots_per_user.value : 0,
      plans: this.selectedPlan.toString(),
      expiry: (this.addPromoCodeForm.controls.expiry.value) ? this.addPromoCodeForm.controls.expiry.value : '',
      status: this.addPromoCodeForm.controls.status.value,
      created_by: this.userId,
      updated_by: this.userId
    };


    this.addCouponCode(addPayload);

  }

  checkValue() {
    const selectedplans = this.tempPromoCodeList.filter(plan=>this.selectedPlan.includes(plan._id)),
    invalidPlanValue = [];
    selectedplans.map(plan=>{
      const taxRate = plan.regions ? plan.regions.tax.rate : 0,
      base = plan.is_tax_inclusive
        ? parseFloat(((100 * plan.price) / (100 + taxRate)).toFixed(2))
        : plan.price,
      main = {
          rate: plan.discount,
          value: parseFloat(((base * plan.discount) / 100).toFixed(2))
        },
      premium = {
        rate: 0,
        value: parseFloat(((base * 0) / 100).toFixed(2))
      },
      subTotal = parseFloat((base - main.value - premium.value).toFixed(2)),
      couponObj = {
        value:
          this.selectedKind === "COUPON_FLAT"
            ? this.mentionedValue
            : parseFloat(((subTotal * this.mentionedValue) / 100).toFixed(2))
      };
      console.log(plan.name, plan.regions)
      console.log("subTotal",subTotal)
      console.log("couponObj",couponObj)
      if(
        subTotal < couponObj.value
      ){
        invalidPlanValue.push(plan);
      }
    })
    if(invalidPlanValue.length) this.invalidValue = true;
    else this.invalidValue = false;
  }
  updatePromoCodeList() {
    this.promoCodeList = (this.selectedRegion.length ? this.tempPromoCodeList.filter(plan=> plan.type === this.selectedType && this.selectedRegion.includes(plan.regions ? plan.regions["_id"] : "")) : this.tempPromoCodeList).map(plan=>`${plan.type}-${plan.name}-${plan.regions ? plan.regions.name : ""}`);
  }

  addCouponCode(payload) {
    this.pricesService.addCouponCode(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate(['/get-couponcodes']);
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Add CouponCodes', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Add CouponCodes', error);
        });
  }

  getRegions() {
    this.regionService.getRegions()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.regionList = data.Data;
            this.regionDropdownData = data.Data.map(regionObject => regionObject.name);
                    }
        },
        error => {
          console.log('Region', error);
        });
  }


  getPlans() {
    this.pricesService.getPlanList()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.promoCodeList = data.promoCodeList.map(plan=>`${plan.type}-${plan.name}-${plan.regions ? plan.regions.name : ""}`);
            this.tempPromoCodeList = data.promoCodeList;
            this.isDataAvailable = true;
          }
        },
        error => {
          console.log('Plans', error);
        });
  }

}
